import { AbstractMouseEvent } from './AbstractMouseEvent';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class MouseUpEvent extends AbstractMouseEvent {
  upEvent: CGSMouseEvent;

  constructor(mouse: Mouse, event: CGSMouseEvent, upEvent: CGSMouseEvent) {
    super(mouse, event);
    this.upEvent = upEvent;
  }
}
